import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'virtues-bootstrap';

import CommonHeader from './CommonHeader';

import s from './styles.module.scss';

const AdminHeader = ({ authLogout }) => (
  <CommonHeader>
    <Col className={s.logoutCol} xs={9}>
      <Button onClick={authLogout} variant="link">
        Logout
      </Button>
    </Col>
  </CommonHeader>
);

AdminHeader.propTypes = {
  authLogout: PropTypes.func.isRequired,
};

export default AdminHeader;
